import { render, staticRenderFns } from "./AppCard_desktop.vue?vue&type=template&id=180c7458&scoped=true&"
import script from "./AppCard_desktop.vue?vue&type=script&lang=js&"
export * from "./AppCard_desktop.vue?vue&type=script&lang=js&"
import style0 from "./AppCard_desktop.vue?vue&type=style&index=0&id=180c7458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c7458",
  null
  
)

export default component.exports